var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{style:({'direction': _vm.$vs.rtl ? 'rtl' : 'ltr'})},[_c('span',{staticClass:"feather-icon select-none relative switch-publish"},[_c('vs-switch',{model:{value:(_vm.params.data.HideInList),callback:function ($$v) {_vm.$set(_vm.params.data, "HideInList", $$v)},expression:"params.data.HideInList"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }